import React from 'react';
import { Spacer as Spacer$1 } from '@zillow/constellation';
import PropTypes from 'prop-types';
import { CustomPropTypes } from '@zillow/zrs-cms';

var BlockSpacer = function BlockSpacer(_ref) {
  var attrs = _ref.attrs,
    index = _ref.index;
  var _attrs$paddingTop = attrs.paddingTop,
    paddingTop = _attrs$paddingTop === void 0 ? {
      default: 'lg',
      lg_lte: 'md',
      sm_lte: 'sm'
    } : _attrs$paddingTop;
  return /*#__PURE__*/React.createElement(Spacer$1, {
    key: index,
    paddingTop: paddingTop
  });
};
BlockSpacer.propTypes = process.env.NODE_ENV !== "production" ? {
  attrs: PropTypes.shape({
    paddingTop: CustomPropTypes.inlineMediaQuery(PropTypes.string)
  }),
  index: PropTypes.number
} : {};
var Spacer = BlockSpacer;

export { Spacer as default };
